<template>
  <div style="height: 800px; width: 100%">
    <l-map
      v-if="showMap"
      :zoom="zoom2"
      :maxZoom="22"
      :center="center"
      :options="mapOptions"
      style="height: 100%"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
      :key="itemkey"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-circle
        v-for="(item, key) in listData"
        :lat-lng="item.location"
        :key="key"
        :radius="item.radius"
        :color="circle.color"
        :fillColor="circle.fillColor"
        :fillOpacity="circle.fillOpacity"
      />
      <l-image-overlay
        v-if="isMap"
        :url="`https://portail.pilote.immo/clients/ecran/${params.id}/map.png`"
        :bounds="bounds"
      />
      <l-marker
        v-for="(item, key) in listData"
        :lat-lng="item.location"
        :key="key"
        @click="goToLink(item.link)"
      >
        <l-icon
          v-if="isOpe"
          :icon-size="Size"
          :icon-anchor="Anchor"
          :icon-url="
            `https://portail.pilote.immo/img/map/${item.operationnel}.png`
          "
        />

        <l-tooltip
          :options="{
            permanent: true,
            interactive: true,
            direction: 'bottom',
            offset: [0, 2]
          }"
        >
          <h3>
            {{ item.name }}
          </h3>
        </l-tooltip>
      </l-marker>
    </l-map>
    <l-map v-else>
      <br /><br /><br /><br /><br /><br /><br /><br />Pas d'élément, rien à
      afficher
    </l-map>
  </div>
</template>

<script>
import { latLng } from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip,
  LImageOverlay,
  LCircle,
  LIcon
} from "vue2-leaflet";
import { mapGetters } from "vuex";

export default {
  name: "MapRaduis",
  props: ["lat", "lng", "name", "operationnel", "list"],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LTooltip,
    LCircle,
    LIcon
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      bounds: [
        [0, 0],
        [0, 0]
      ],
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 11.5,
      zoom2: 11.5,
      currentCenter: null,
      showParagraph: false,
      isMap: "",
      circle: {
        color: "grey",
        fillColor: "grey",
        fillOpacity: 0.2
      },
      mapOptions: {
        zoomSnap: 0.5
      },
      itemkey: 1,
      Size: [60, 60],
      Anchor: [30, 60],
      hasData: false,
      leafleterrortest: 0
    };
  },
  created() {
    this.loadModulesData();
  },
  computed: {
    ...mapGetters(["getUUID"]),
    params() {
      return {
        id: this.$route.params.id
      };
    },
    showMap() {
      if (this.list.length !== 0) {
        return true;
      }
      return false;
    },
    listData() {
      return this.list.map(el => {
        return {
          name: el.name,
          location: latLng(el.lat, el.lng),
          link: el.link,
          operationnel: el.operationnel,
          radius: el.radius
        };
      });
    },
    location() {
      const lat = this.list && this.list[0] ? this.list[0].lat : 0;
      const lng = this.list && this.list[0] ? this.list[0].lng : 0;
      return latLng(lat, lng);
    },
    center() {
      if (this.list[0]) {
        let maxlat = this.list[0].lat;
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].lat > maxlat) {
            maxlat = this.list[i].lat;
          }
        }
        let minlat = this.list[0].lat;
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].lat < minlat) {
            minlat = this.list[i].lat;
          }
        }
        let maxlng = this.list[0].lng;
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].lng > maxlng) {
            maxlng = this.list[i].lng;
          }
        }
        let minlng = this.list[0].lng;
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].lng < minlng) {
            minlng = this.list[i].lng;
          }
        }
        if (this.list.length == 1) {
          return this.location;
        }
        let midlat = (parseFloat(maxlat) + parseFloat(minlat)) / 2;
        let midlng = (parseFloat(maxlng) + parseFloat(minlng)) / 2;
        return latLng(midlat, midlng);
      } else {
        return latLng(45, 7);
      }
    },
    isOpe() {
      if (this.list[0].operationnel === undefined) {
        return false;
      } else {
        return true;
      }
    },
    zoom() {
      if (this.list[0]) {
        let maxlat = this.list[0].lat;
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].lat > maxlat) {
            maxlat = this.list[i].lat;
          }
        }
        let minlat = this.list[0].lat;
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].lat < minlat) {
            minlat = this.list[i].lat;
          }
        }
        if (this.list.length == 1) {
          return 13;
        } else {
          let diflat = parseFloat(maxlat) - parseFloat(minlat);
          if (diflat < 0.0009) {
            return 17.5;
          } else if (diflat < 0.01) {
            return 15;
          } else if (diflat < 0.12) {
            return 14;
          } else if (diflat < 1.2) {
            return 9;
          } else if (diflat < 2.5) {
            return 7;
          } else if (diflat < 4.3) {
            return 6;
          } else {
            return 5.2;
          }
        }
      } else {
        return 9;
      }
    }
  },
  methods: {
    loadModulesData() {
      let id = this.$route.params.id;
      if (this.$route.name === "lots.show") {
        if (id) {
          fetch(`https://portail.pilote.immo/clients/ecran/${id}/map.php`)
            .then(response => {
              return response.json();
            })
            .then(data => {
              if (data) {
                this.mapOverlay(data);
              }
            })
            .catch(function() {
              // catch any errors
            });
        }
      } else {
        this.zoom2 = this.zoom;
      }
    },
    mapOverlay(d) {
      if (this.leafleterrortest == 0 && d.param.map === "oui") {
        this.bounds = d.param.coords;
        this.isMap = true;
        this.zoom2 = d.param.zoom;
        this.leafleterrortest = 1;
      }
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    goToLink(link) {
      if (link == undefined) {
        link = null;
      } else if (typeof link !== "string") {
        if (
          this.$route.name !== "assets.show" ||
          this.$route.name !== "lots.show"
        )
          this.$router.push(link);
      } else {
        window.open(link);
      }
    }
  },
  watch: {
    params() {
      this.loadModulesData();
    },
    list: {
      deep: true,
      handler: function() {
        this.itemkey++;
      }
    }
  }
};
</script>
